import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {graphql, Query} from 'react-apollo';
import {NetworkError} from 'components/GraphQLError/NetworkError/index';


export const USER_QUERY = gql`
query me {
  me {
    id
    firstName
    lastName
    email
    language
    gender
    isSuperUser
  }
}
`;

export const userShape = PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string
});


export function withUser(WrappedComponent) {
    class WithUser extends React.Component {
        render() {
            const {data, ...props} = this.props;
            const {loading, me} = data;

            return <WrappedComponent loadingUser={loading} user={me} {...props} />;
        }
    }

    WithUser.propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool,
            me: userShape
        })
    };

    WithUser.defaultProps = {
        data: {loading: false, me: {}}
    };

    return graphql(USER_QUERY)(WithUser);
}

export class WithUser extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        renderError: PropTypes.func,
        onCompleted: PropTypes.func
    };

    static defaultProps = {
        renderError: (error, refetch) => <NetworkError error={error} refetch={refetch}/>
    };

    render() {

        return (
            <Query fetchPolicy={'cache-and-network'} notifyOnNetworkStatusChange={true} query={USER_QUERY} onCompleted={this.props.onCompleted}>
                {({data, loading, error, refetch}) => {
                    if (error) {
                        return this.props.renderError(error, refetch);
                    }

                    return this.props.children({user: data.me, loading});
                }}
            </Query>
        );
    }
}
